module.exports = __webpack_public_path__ + "img/caret-left.aa28dd77.svg";